const axios = require("axios");
const UAParser = require("ua-parser-js");
var moment = require("moment");
const { times } = require("lodash");

class Send_cloudFuction {
  constructor() {
    this.target = document.querySelector("body");
    this.url =
      "https://asia-northeast1-food-expo-web.cloudfunctions.net/product_bq_insert";
    this.uaParser = UAParser();
  }

  init() {
    this.getData();

    console.log(data);
    

    axios
      .post(this.url, data)
      .then((response) => {
        console.log("接続成功");
      })
      .catch((err) => {
        console.log("err:", err);
      });
  }

  getData() {
    return (data = {
      page_type: this.target.dataset.page_type ? this.target.dataset.page_type : null,
      user_type: this.target.dataset.user_type ? this.target.dataset.user_type : null,
      user_id: this.target.dataset.user_id ? this.target.dataset.user_id : null,
      seller_item_id: this.target.dataset.seller_item_id ? this.target.dataset.seller_item_id : null,
      categories: this.target.dataset.categories ? this.target.dataset.categories : null,
      search_categories: this.target.dataset.search_categories ? this.target.dataset.search_categories : null,
      search_prefectures: this.target.dataset.search_prefectures ? this.target.dataset.search_prefectures : null,
      search_words: this.target.dataset.search_words ? this.target.dataset.search_words : null,
      conversion_button: this.target.dataset.conversion_button ? this.target.dataset.conversion_button : null,
      browser: this.getBrowser(),
      device: this.getDevice(),
      created_at: moment(new Date()).format('YYYY-MM-DD h:mm:ss'),
      buyer_id: this.target.dataset.buyer_id ? this.target.dataset.buyer_id : null,
      seller_id: this.target.dataset.seller_id ? this.target.dataset.seller_id : null,
    });
  }

  getBrowser() {
    return this.uaParser.browser.name.replace(/\s+/g, "").toLowerCase();
  }

  getDevice() {
    const type = this.uaParser.device.type;
    let type_result = "";
    if (type == "mobile") {
      type_result = "sp";
    } else if (type == "tablet") {
      type_result = "tb";
    } else {
      type_result = "pc";
    }
    return type_result;
  }

  getOS() {
    return this.uaParser.os.name.replace(/\s+/g, "").toLowerCase();
  }
}

const SendCloudFunction = new Send_cloudFuction();

window.onload = function () {
  if ($("body.logined").length) {
    // if (window.performance.navigation.type !== 1) {
      if (document.querySelector("body").dataset.user_id) {
        SendCloudFunction.init();
      }
    // }
  }
};
